import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import utils from "../../../utils/validateScanner"

export default {
	name: 'bagroutemodechanges',
	mixins: [utils],
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		DatePicker
	},
	data: function() {
		return {
			pageCount: 0,
			pageNo: 0,
			pageLimit: 5,
			totalRows: 0,
			resultCount: 0,

			isLoading: false,
			bagno: '',
			FromDate: '',
			ToDate: '',
			bagstatus: '',
			validListFlag: false,

			listBagData: [],
			userHubid: '',

			showApproveBagFlag: false,
			apiResponseFlag: false,

			bagnoadd: '',
			bagAction: '',
			comment: '',
			listChangeResult: [],

		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.userHubid = userdetail[0].HubId[0];

	},
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		showBagRouteApprovalForm() {
			this.showApproveBagFlag = true;
			this.validListFlag = false;
			this.resetForm();
		},
		hideBagRouteChangeForm() {
			this.clearChangeRouteForm();
			this.showApproveBagFlag = false;
			this.apiResponseFlag = false;
		},
		/// Function to Get the list of  Bags
		getBagRouteList() {

			if (this.validateFlag == true) {
				this.input = ({})
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'bagRouteModeChangeRequestListAll?BagNo=' + this.bagno + '&Status=' + this.bagstatus + '&FromDate=' + this.dateFormat(this.FromDate) + '&ToDate=' + this.dateFormat(this.ToDate) + '&PageSize=' + this.pageLimit + '&PageIndex=' + this.pageNo,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						this.isLoading = false;
						if (result.data.ResultCode == 100) {
							if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
								this.colorCode = result.data.lossCategorization.colorCode;
								this.colorIcon = result.data.lossCategorization.icon;
							}
							this.validListFlag = true;
							this.listBagData = result.data.ResponseData;
							let totalRows = result.data.TotalCount;
							this.resultCount = result.data.TotalCount;
							if (this.resultCount > 0) {
								if (totalRows < this.pageLimit) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(totalRows / this.pageLimit)
								}
							}
						} else {
							this.validListFlag = false;
							this.$alertify.error(result.data.ReturnMessage);
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			} else {
				return false;
			}
		},

		saveApproveBagRequest() {
			if (this.bagnoadd == "") {
				return false;
			}
			if (this.bagAction == "") {
				return false;
			}
			if (this.comment == "") {
				return false;
			}

			this.input = ({
				BagNos: this.bagnoadd,
				Comment: this.comment,
				RequestStatus: this.bagAction,
				LastModifiedBy: this.useremail
			})

			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'bagRouteModeChangeRequestApprove',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Request Sent Successfully');
						this.listChangeResult = result.data.ResponseData;
						this.apiResponseFlag = true;
					}
					//this.getGroupTemplates();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})

		},
		clearChangeRouteForm() {
			this.bagnoadd = '';
			this.bagAction = '';
			this.comment = '';
			this.$validator.reset();
		},

		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1);
			this.getBagRouteList();
		},

		//to reset search form
		resetForm() {

			this.bagno = '';
			this.FromDate = '';
			this.ToDate = '';
			this.bagstatus = '';
			this.pageCount = 0;
			this.listBagData = [];
			this.pageNo = 0 ;
			this.validListFlag = false;
			document.getElementById("bagno").value = "";
			//console.log(this.modeObjData);
			this.$validator.reset();
			this.showHideCodeIconInput();

		},

		//validate all form fields on onsubmit()
		onSubmit: function(formname) {
			this.$validator.validateAll().then((formResult) => {
					if (formResult == false) {
						this.validateFlag = false
					} else {
						this.validateFlag = true;
						if (this.showApproveBagFlag == false) {
							this.pageNo = 0 ;
							this.getBagRouteList();
						} else {
							//this.saveChangeBagRoute();
						}
						console.log('form is valid')
					}

				})
				.catch(() => {
					console.log('errors exist')
				});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/RouteModeChangeApproval/RouteModeChangeApproval_component.js